import React from 'react'
import { Image, OverlayTrigger } from 'react-bootstrap'

const RenderImage = (imageProp) => {
    const renderFullImage = (imageProp) => {
        return (
            <Image className="fullimage" src={imageProp} />
        )
    }

    const handleClick = (e) => {
        e.stopPropagation()
    }

    return (
        <OverlayTrigger overlay={renderFullImage(imageProp)} placement="right" rootClose trigger={['click', 'hover', 'focus']} >
            <Image className="thumbnail" src={imageProp} thumbnail onClick={handleClick} />
        </OverlayTrigger>
    )
}

export { RenderImage }